import eventMixin from '../lib/mixins/event';
import Logger from '../lib/logger';

export default class SectionSocialProof {

	constructor(dom) {

		// Vars
		// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
		this.NAME = `SectionSocialProof`;

		this.isScrolling = false;

		this.dom = dom;
		this.domActiveClass = `section-social-proof--active`;
		this.scrollerDom = this.dom.querySelector(`[data-section-social-proof-scroller]`);
		this.logosGroupDom = this.dom.querySelector(`[data-section-social-proof-logos]`);

		this.resizeTimeout = null;
		this.scrollInterval = null;
		this.resizeObserver = null;
		this.intersectionObserver = null;
		this.scrollSpeed = this.dom.getAttribute(`data-section-social-proof-scroller-speed`) || 8000;
		this.scrollDistance = 0;

	}

	// Logic
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
	init() {
		Logger.info(`${this.NAME} > init`);

		const self = this;

		setTimeout(() => {
			this.measureLogos();
			this.bindResizeHandler();
		}, 1000);

		this.intersectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const intersecting = entry.isIntersecting;

				if (intersecting && !this.isScrolling) {
					setTimeout(() => {
						self.start();
					}, 1000);
				} else if (!intersecting && this.isScrolling) {
					self.stopScrolling();
				}
			});
		});

		this.intersectionObserver.observe(this.dom);
	}

	bindResizeHandler() {
		const self = this;

		const onResize = () => {
			self.hide();
			clearTimeout(this.resizeTimeout);
			this.resizeTimeout = setTimeout(() => {
				self.measureLogos();
				self.start();
				setTimeout(self.show.bind(self), 2000);
			}, 500);
		};

		if (typeof ResizeObserver !== 'undefined') {
			this.resizeObserver = new ResizeObserver(onResize);
			this.resizeObserver.observe(this.dom);
			return;
		}

		window.addEventListener('resize', onResize);
	}

	hide() {
		Logger.info(`${this.NAME} > hide`);
		this.dom.classList.remove(this.domActiveClass);
	}

	/**
	 * Read layout dimensions, then apply DOM updates in the next frame.
	 */
	measureLogos() {
		Logger.info(`${this.NAME} > measureLogos`);

		if (!this.logosGroupDom || !this.scrollerDom) {
			return;
		}

		const logosGroupWidth = this.logosGroupDom.offsetWidth;
		const parentWidth = this.dom.offsetWidth;

		if (logosGroupWidth < 1 || parentWidth < 1) {
			return;
		}

		const minimumGroups = Math.ceil(parentWidth / logosGroupWidth) * 2;
		const scrollDistance = (minimumGroups * logosGroupWidth) / 2;
		const template = this.logosGroupDom;

		requestAnimationFrame(() => {
			const allGroups = this.scrollerDom.querySelectorAll(`[data-section-social-proof-logos]`);
			allGroups.forEach((group, i) => {
				if (i === 0) return;
				group.remove();
			});

			for (let i = 0; i < minimumGroups; i++) {
				const clonedGroup = template.cloneNode(true);
				clonedGroup.setAttribute('data-section-social-proof-logos', '');
				this.scrollerDom.appendChild(clonedGroup);
			}

			this.scrollDistance = scrollDistance;
			this.reset();
		});
	}

	reset() {
		Logger.info(`${this.NAME} > reset`);

		this.scrollerDom.style.transition = `none`;
		this.scrollerDom.style.transform = `translateX(0px)`;
	}

	show() {
		Logger.info(`${this.NAME} > show`);
		this.dom.classList.add(this.domActiveClass);
	}

	scroll() {
		Logger.info(`${this.NAME} > scroll`);

		this.reset();

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.scrollerDom.style.transition = `${this.scrollSpeed / 1000}s transform linear`;
				this.scrollerDom.style.transform = `translateX(-${this.scrollDistance}px)`;
				this.show();
				this.isScrolling = true;
			});
		});
	}

	start() {
		Logger.info(`${this.NAME} > start`);
		clearInterval(this.scrollInterval);
		this.scroll();
		this.scrollInterval = setInterval(this.scroll.bind(this), this.scrollSpeed);
	}

	stopScrolling() {
		Logger.info(`${this.NAME} > stopScrolling`);
		clearInterval(this.scrollInterval);
		this.hide();
		this.reset();
		this.isScrolling = false;
	}

}

Object.assign(SectionSocialProof.prototype, eventMixin);
